import React from 'react';
import { createPortal } from 'react-dom';
import { StorySettingsType } from 'types/story';
import { SYSTEM_FONTS } from 'common/constants';

type Props = {
	fonts: StorySettingsType['fonts'];
};

const GoogleFonts = (props: Props) => {
	const fonts = { ...SYSTEM_FONTS, ...props.fonts };

	const href = Object.values(fonts).reduce((memo, value) => {
		/* eslint-disable no-param-reassign */
		if (value.fontType === 'google') {
			memo += `${!memo ? 'https://fonts.googleapis.com/css?family=' : '|'}${value.url}`;
		}
		/* eslint-enable no-param-reassign */
		return memo;
	}, '');

	if (!href) {
		return null;
	}

	return createPortal(<link href={href} rel="stylesheet" />, document.head);
};

export default GoogleFonts;
